// Pathify
import { make } from 'vuex-pathify'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  items: [
    /*{
      title: 'Viewing Affected Asset',
      icon: 'mdi-road-variant',
      to: '/asset_management/',
    },*/
    {
      title: 'Rehabilitation Plan Submission',
      icon: 'mdi-notebook-multiple',
      to: '/disaster_need/',
    },    
    {
      title: 'Notification of Rehabilitation Needs Plan Submission',
      icon: 'mdi-folder-clock',
      to: '/project_application_provision/',
    },
    {
      title: 'Project Application',
      icon: 'mdi-application-import',
      to: '/project_application/',
    },
    {
      title: 'Management of Affected Areas',
      icon: 'mdi-weather-lightning',
      to: '/disaster_management/',
    },
    {
      title: 'Project Application Approval',
      icon: 'mdi-check-bold',
      to: '/project_application_approval/',
    },{
      title: 'Budget Management',
      icon: 'mdi-cash',
      to: '/project_id_budget_mgt/',
    },{
      title: 'Rehabilitation Plan Implementation',
      icon: 'mdi-cash',
      to: '/project_budget/',
    },{
      title: 'Contractor',
      icon: 'mdi-pickaxe',
      to: '/project_contractor/',
    },{
      title: 'Project Progress Reporting',
      icon: 'mdi-folder-clock',
      to: '/implementation_reporting/',
    }/*,{
      title: 'Project Progress Reporting Approval',
      icon: 'mdi-check-bold',
      to: '/implementation_approval/',
    },{
      title: 'Payment Update',
      icon: 'mdi-cash',
      to: '/payment_progress/',
    },{
      title: 'Project Completion Reporting',
      icon: 'mdi-folder-clock',
      to: '/completion_reporting/',
    },{
      title: 'Project Completion Reporting Approval',
      icon: 'mdi-check-bold',
      to: '/completion_approval/',
    }*/,{
      title: 'Project Overview',
      icon: 'mdi-file-search-outline',
      to: '/project_overview/',
    }/*,{
      title: 'Project Management',
      icon: 'mdi-application',
      to: '/project_management/',
    },{
      title: 'Budget Management',
      icon: 'mdi-currency-usd',
      to: '/budget_management/',
    },{
      title: 'Contractor and VFM Statement',
      icon: 'mdi-archive',
      to: '/project_contractor/',
    }*//*,{
      title: 'Dashboard',
      icon: 'mdi-chart-bar', //mdi-view-dashboard',
      to: '/dashboard/',
    }*//*,{
      title: 'Search Function',
      icon: 'mdi-folder-search-outline',
      to: '/search_function/',
    }*/,
    {
      title: 'User Right Access Management',
      icon: 'mdi-account',
      to: '/user_right_management/',
    },
    {
      title: 'Information',
      icon: 'mdi-information',
      to: '/info/',
    },





    /*{
      title: 'OldDashboard',
      icon: 'mdi-view-dashboard',
      to: '/',
    },
    {
      title: 'Disaster V1 Mgt',
      icon: 'mdi-application',
      to: '/disaster_management_v1/',
    },
    {
      title: 'Disaster V2 Mgt',
      icon: 'mdi-application',
      to: '/disaster_management_v2/',
    },
    {
      title: 'Asset Management V1',
      icon: 'mdi-anvil',
      to: '/asset_management_v1/',
    },
    {
      title: 'Project Management V1',
      icon: 'mdi-application',
      to: '/project_management_v1/',
    },
    {
      title: 'User Profile',
      icon: 'mdi-account',
      to: '/components/profile/',
    },
    {
      title: 'Regular Tables',
      icon: 'mdi-clipboard-outline',
      to: '/tables/regular/',
    },
    {
      title: 'Typography',
      icon: 'mdi-format-font',
      to: '/components/typography/',
    },
    {
      title: 'Icons',
      icon: 'mdi-chart-bubble',
      to: '/components/icons/',
    },
    {
      title: 'Google Maps',
      icon: 'mdi-map-marker',
      to: '/maps/google/',
    },
    {
      title: 'Notifications',
      icon: 'mdi-bell',
      to: '/components/notifications/',
    },*/
  ],
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
